import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { csSendOtp, csConfirmOtp } from "../../api/verify.api";
import { csSession } from "../../auth/session";
import styles from "../../styles/login.module.css";

export default function VerifyPhone() {
  const nav = useNavigate();
  const phone = csSession.getPhone();

  const [code, setCode] = useState(["", "", "", "", "", ""]);
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const [sent, setSent] = useState(false);
  const [cooldown, setCooldown] = useState(0); // saniyə
  const inputsRef = useRef([]);
  const didAutoSend = useRef(false);

  useEffect(() => {
    if (!phone) nav("/couriersub/login");
  }, [phone, nav]);

  // cooldown timer
  useEffect(() => {
    if (cooldown <= 0) return;
    const t = setInterval(() => setCooldown((s) => s - 1), 1000);
    return () => clearInterval(t);
  }, [cooldown]);

  const sendOtp = async ({ silent = false } = {}) => {
    if (!phone) return;
    if (cooldown > 0) return; // spam olmasın

    if (!silent) setMsg("");
    try {
      setLoading(true);
      await csSendOtp(phone);
      setSent(true);
      setCooldown(60); // 60 saniyə sonra yenidən göndərmək olar
      if (!silent) setMsg("Doğrulama kodu WhatsApp vasitəsilə göndərildi.");
    } catch (err) {
      setMsg(
        err?.response?.data?.message ||
        err?.message ||
        "Kod göndərilmədi."
      );
    } finally {
      setLoading(false);
    }
  };

  // səhifə açılan kimi 1 dəfə avtomatik göndər
  useEffect(() => {
    if (!phone) return;
    if (didAutoSend.current) return;
    didAutoSend.current = true;
    sendOtp({ silent: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [phone]);

  const confirmOtp = async () => {
    const otp = code.join("");
    if (otp.length !== 6) return setMsg("6 rəqəmli kodu daxil edin.");

    setMsg("");
    try {
      setLoading(true);
      await csConfirmOtp(phone, otp);
      const u = csSession.getUser() || {};
      csSession.setUser({ ...u, verifyStatus: "PHONE_VERIFIED" });
      nav("/couriersub/docs");
    } catch (err) {
      setMsg(
        err?.response?.data?.message ||
        err?.message ||
        "Kod yanlışdır."
      );
    } finally {
      setLoading(false);
    }
  };

  const onChange = (i, val) => {
    if (!/^\d?$/.test(val)) return;

    const next = [...code];
    next[i] = val;
    setCode(next);

    if (val && i < 5) inputsRef.current[i + 1]?.focus();
  };

  const onKeyDown = (i, e) => {
    if (e.key === "Backspace" && !code[i] && i > 0) {
      inputsRef.current[i - 1]?.focus();
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.header}>
          <div className={styles.brand}>MotoTaksi.az</div>
          <h1 className={styles.title}>Telefon Doğrulama</h1>
          <p className={styles.subtitle}>
            <b>{phone}</b> nömrəsinə göndərilən 6 rəqəmli kodu daxil edin
          </p>
        </div>

        <div className={styles.form}>
          <div className={styles.otpGrid}>
            {code.map((v, i) => (
              <input
                key={i}
                ref={(el) => (inputsRef.current[i] = el)}
                className={styles.otpInput}
                maxLength={1}
                value={v}
                onChange={(e) => onChange(i, e.target.value)}
                onKeyDown={(e) => onKeyDown(i, e)}
                inputMode="numeric"
              />
            ))}
          </div>

          <button
            className={styles.btn}
            onClick={confirmOtp}
            disabled={loading}
            style={{ marginTop: 14 }}
            type="button"
          >
            {loading ? "Yoxlanılır..." : "Təsdiqlə"}
          </button>

          {/* Yenidən göndər */}
          <button
            type="button"
            onClick={() => sendOtp()}
            disabled={loading || cooldown > 0}
            style={{
              marginTop: 8,
              background: "transparent",
              border: "none",
              color: cooldown > 0 ? "#888" : "#06f",
              fontWeight: 700,
              cursor: loading || cooldown > 0 ? "not-allowed" : "pointer",
            }}
          >
            {cooldown > 0
              ? `Yenidən göndər (${cooldown}s)`
              : sent
                ? "Kodu yenidən göndər"
                : "Kodu göndər"}
          </button>

          {msg && <div className={styles.error}>{msg}</div>}
        </div>
      </div>
    </div>
  );
}

